import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaFilter, ISchemaProperty } from "../Schema";
import { FilterTypes } from "../../../../enums/FilterTypes";
import { FilterMatchType } from "../../../../enums/FilterMatchType";
import SidePanelReturnsView from "../../layout/SidePanel/layouts/SidePanelReturnsView";

export const CustomerReturnsSchema: ISchema = {
    displayName: "Returns",
    resultsKey: "returns",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelReturnsView data={data} onViewPage={onViewPage}/>,
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'reference',
            displayName: 'Reference',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'dateRequested',
            displayName: 'Date Requested',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'createdBy',
            displayName: 'Created By',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,    
        {
            name: 'status',
            displayName: 'Status',
            type: PropertyTypes.status,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
    ],

    primaryFilter: {
        PropertyName: "Reference",
        displayName: "Search",
        type: FilterTypes.search,
        required: false,
        className: "width--full",
        matchType: FilterMatchType.Equal,
        propertyType: PropertyTypes.string
    } as ISchemaFilter,

    filters: [
        {
            PropertyName: "Status",
            entityName: "upliftStatuses",
            displayName: "Status",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.int
        } as ISchemaFilter,
    ],
    children: [ ],
};
